export default "__VITE_ASSET__e38db1cf__"